import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../context/appcontext";
import * as RolePermissionConstants from "../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";

const GlobalLinks = (props) => {
  const context = useContext(AppContext);

  return (
    <ul>
      {props.links &&
        props.links.map((value, i) => {
          if (context && context.roles) {
            if (
              getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_MACYHOME_ALLNOTIFICATIONS,
                RolePermissionConstants.ALL
              ) !== RolePermissionConstants.NONE ||
              getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_MACYHOME_ALLRESOURCES,
                RolePermissionConstants.ALL
              ) !== RolePermissionConstants.NONE
            ) {
              return (
                <li className="listType1" key={i}>
                  <Link
                    to={value.linkTo}
                    id={value.linkName}
                    className="linkStyle"
                    style={{
                      textDecoration: "none",
                      pointerEvents:
                        value.linkName === "Seller Hub" ? "none" : "",
                      color:
                        value.linkName === "Seller Hub" ? "#999999" : "#1395c5",
                    }}
                  >
                    {value.linkName}
                  </Link>
                </li>
              );
            }
          }
        })}
    </ul>
  );
};

export default GlobalLinks;
